import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';
import { BRAND } from '../../theme/brandTokens';
import { brandBackdropSx } from '../../theme/brandSurfaces';

const ShortLinkRedirectPage = () => {
  const { token } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    if (!token) {
      return;
    }

    const apiBaseUrl = (api.defaults.baseURL || '/api').replace(/\/$/, '');
    window.location.replace(`${apiBaseUrl}/l/${encodeURIComponent(token)}`);
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 2,
        ...brandBackdropSx,
      }}
    >
      <CircularProgress sx={{ color: BRAND.accentLight }} />
      <Typography variant="body1" sx={{ color: BRAND.onPrimaryMuted }}>
        {t('shortLink.redirecting')}
      </Typography>
    </Box>
  );
};

export default ShortLinkRedirectPage;
